module.exports = __webpack_public_path__ + "static/Animals-e6710d355e561775485bf863af59471e.webm";